import React from 'react';
import type { InspireDeliveryDetailed } from '../../../lib/types/InspireDeliveryDetailed';
import { InspireDeliveryPage } from '../../components/InspireDeliveryPage';

interface AppInitialProps {
  inspireDelivery: InspireDeliveryDetailed;
}

const App = ({ inspireDelivery }: AppInitialProps) => {
  return <InspireDeliveryPage inspireDelivery={inspireDelivery} />;
};

export default App;
